import React, { useEffect, useState } from 'react';
import '../styles/pages/AboutUs.scss';
import { GoArrowDownRight } from "react-icons/go";
import confidentialite from '../assets/aboutUsIcons/confidentialite.png';
import efficace from '../assets/aboutUsIcons/efficace.png';
import fiable from '../assets/aboutUsIcons/fiable.png';
import aboutus1 from '../assets/aboutus1.png';
import aboutus2 from '../assets/aboutus2.png';
import { useTranslation } from 'react-i18next';

const AboutUs = () => {
  const { t } = useTranslation();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const isMobile = windowWidth < 768;
  
  return (
    <div className="aboutus-page">
      {/* Top Section */}
      <section className="aboutus-top">
        <h1>{t('about.title')}</h1>
        <p className="aboutus-desc">
          {t('about.content')}
        </p>
        <hr style={{width: '65%'}}></hr>
      </section>

      {/* Vision Section */}
      <section className="aboutus-vision-imgs">
        <div className="vision-imgs-row">
          <img src={aboutus1} alt={t('about.team_alt')} className="vision-img" style={{width: isMobile ? '90%' : '55%'}} />
          <img src={aboutus2} alt={t('about.team_alt')} className="vision-img" style={{width: isMobile ? '90%' : '45%'}} />
        </div>
      </section>

      {/* Our Vision */}
      <section className="aboutus-vision-block">
          <div className="vision-expertise">
            <h1>{t('about.vision.title')} <GoArrowDownRight size={56} /></h1>
            <div className="expertise-box">
              <span style={{fontWeight: '600'}}>{t('about.vision.experience_years')}</span>
              <span>{t('about.vision.experience_label')}</span>
            </div>
          </div>
          <div className="vision-text">
            <p>
              {t('about.vision.content')}
            </p>
          </div>
      </section>

      {/* Our Values */}
      <section className="aboutus-values">
        <h1>{t('about.values.title')} <GoArrowDownRight size={56} /></h1>
        <div className="values-row">
          <div className="value-card">
            <div className="value-icon">
              <img src={fiable} alt={t('about.values.reliable.alt')} />
            </div>
            <div className="value-label">{t('about.values.reliable.title')}</div>
          </div>
          <div className="value-card">
            <div className="value-icon">
              <img src={confidentialite} alt={t('about.values.confidential.alt')} />
            </div>
            <div className="value-label">{t('about.values.confidential.title')}</div>
          </div>
          <div className="value-card">
            <div className="value-icon">
              <img src={efficace} alt={t('about.values.efficient.alt')} />
            </div>
            <div className="value-label">{t('about.values.efficient.title')}</div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;